'use strict';

var theme_overrides_accordion = require('../../accordion-2397c51d.js');
var theme_overrides_accordionDetails = require('../../accordion-details-0d01e961.js');
var theme_overrides_accordionSummary = require('../../accordion-summary-45b788cd.js');
var theme_overrides_appBar = require('../../app-bar-93f90640.js');
var theme_overrides_autocomplete = require('../../autocomplete-14341857.js');
var theme_overrides_badge = require('../../badge-7bf62cb8.js');
var theme_overrides_button = require('../../button-5f59739a.js');
var theme_overrides_toggleButton = require('../../toggle-button-b8dc039c.js');
var theme_overrides_toggleButtonGroup = require('../../toggle-button-group-06614a61.js');
var theme_overrides_buttonGroup = require('../../button-group-8e4ef3b2.js');
var theme_overrides_checkbox = require('../../checkbox-968c1a4d.js');
var theme_overrides_chip = require('../../chip-ebf5c0e6.js');
var theme_overrides_dialogActions = require('../../dialog-actions-5bdcc337.js');
var theme_overrides_dialogContent = require('../../dialog-content-1aceacce.js');
var theme_overrides_dialogContentText = require('../../dialog-content-text-6a7df706.js');
var theme_overrides_dialogTitle = require('../../dialog-title-942c98b2.js');
var theme_overrides_divider = require('../../divider-1a75a085.js');
var theme_overrides_formControlLabel = require('../../form-control-label-1279e5c3.js');
var theme_overrides_formLabel = require('../../form-label-f5abd807.js');
var theme_overrides_formHelperText = require('../../form-helper-text-5b194beb.js');
var theme_overrides_iconButton = require('../../icon-button-cfab2859.js');
var theme_overrides_inputAdornment = require('../../input-adornment-78aa29bd.js');
var theme_overrides_inputBase = require('../../input-base-fd0f3e6e.js');
var theme_overrides_inputLabel = require('../../input-label-ffea38fe.js');
var theme_overrides_link = require('../../link-7fbedce8.js');
var theme_overrides_list = require('../../list-6e7a4033.js');
var theme_overrides_listItem = require('../../list-item-3c92df0c.js');
var theme_overrides_listItemIcon = require('../../list-item-icon-6f4247d5.js');
var theme_overrides_listItemText = require('../../list-item-text-e19f4c72.js');
var theme_overrides_menu = require('../../menu-4675ead8.js');
var theme_overrides_menuItem = require('../../menu-item-bee40acc.js');
var theme_overrides_outlinedInput = require('../../outlined-input-fc75a66c.js');
var theme_overrides_pickersDay = require('../../pickers-day-0d29ac09.js');
var theme_overrides_popover = require('../../popover-f7340ac9.js');
var theme_overrides_radio = require('../../radio-697959a0.js');
var theme_overrides_select = require('../../select-26805ec5.js');
var theme_overrides_slider = require('../../slider-f55b6709.js');
var theme_overrides_snackbarContent = require('../../snackbar-content-eeeb8a08.js');
var theme_overrides_switch = require('../../switch-23c2d70a.js');
var theme_overrides_tab = require('../../tab-77dd2fef.js');
var theme_overrides_tabs = require('../../tabs-99124ac5.js');
var theme_overrides_toolbar = require('../../toolbar-4b2c6c32.js');
var theme_overrides_tooltip = require('../../tooltip-9d3d77e5.js');
var theme_overrides_tableCell = require('../../table-cell-87a0d022.js');
var theme_overrides_tableContainer = require('../../table-container-10cf3ac1.js');
var theme_overrides_tableHead = require('../../table-head-ffdb5d82.js');
var theme_overrides_tableRow = require('../../table-row-387bc498.js');
var theme_overrides_tableSortLabel = require('../../table-sort-label-ea697e35.js');
var theme_overrides_table = require('../../table-f1ed3b35.js');
var theme_overrides_cardActionArea = require('../../card-action-area-bdb1666b.js');
var theme_overrides_listSubheader = require('../../list-subheader-32f5e9a2.js');
require('../../variables-1eb6495a.js');
require('../../colorManipulator-abc93889.js');
require('../../index-c6190cd6.js');

const allVariantOverrides = {
    MuiAccordion: theme_overrides_accordion.MuiAccordion,
    MuiAccordionSummary: theme_overrides_accordionSummary.MuiAccordionSummary,
    MuiAccordionDetails: theme_overrides_accordionDetails.MuiAccordionDetails,
    MuiAppBar: theme_overrides_appBar.MuiAppBar,
    MuiToolbar: theme_overrides_toolbar.MuiToolbar,
    MuiTab: theme_overrides_tab.MuiTab,
    MuiTabs: theme_overrides_tabs.MuiTabs,
    MuiBadge: theme_overrides_badge.MuiBadge,
    MuiButton: theme_overrides_button.MuiButton,
    MuiToggleButton: theme_overrides_toggleButton.MuiToggleButton,
    MuiButtonGroup: theme_overrides_buttonGroup.MuiButtonGroup,
    MuiToggleButtonGroup: theme_overrides_toggleButtonGroup.MuiToggleButtonGroup,
    MuiInputAdornment: theme_overrides_inputAdornment.MuiInputAdornment,
    MuiInputLabel: theme_overrides_inputLabel.MuiInputLabel,
    // @ts-ignore
    MuiAutocomplete: theme_overrides_autocomplete.MuiAutocomplete,
    MuiFormHelperText: theme_overrides_formHelperText.MuiFormHelperText,
    MuiFormLabel: theme_overrides_formLabel.MuiFormLabel,
    MuiInputBase: theme_overrides_inputBase.MuiInputBase,
    MuiOutlinedInput: theme_overrides_outlinedInput.MuiOutlinedInput,
    MuiMenuItem: theme_overrides_menuItem.MuiMenuItem,
    MuiPickersDay: theme_overrides_pickersDay.MuiPickersDay,
    MuiSlider: theme_overrides_slider.MuiSlider,
    MuiSwitch: theme_overrides_switch.MuiSwitch,
    MuiSelect: theme_overrides_select.MuiSelect,
    MuiListSubheader: theme_overrides_listSubheader.MuiListSubheader,
    MuiIconButton: theme_overrides_iconButton.MuiIconButton,
    MuiLink: theme_overrides_link.MuiLink,
    MuiList: theme_overrides_list.MuiList,
    MuiListItem: theme_overrides_listItem.MuiListItem,
    MuiListItemIcon: theme_overrides_listItemIcon.MuiListItemIcon,
    MuiListItemText: theme_overrides_listItemText.MuiListItemText,
    MuiPopover: theme_overrides_popover.MuiPopover,
    MuiFormControlLabel: theme_overrides_formControlLabel.MuiFormControlLabel,
    MuiCheckbox: theme_overrides_checkbox.MuiCheckbox,
    MuiRadio: theme_overrides_radio.MuiRadio,
    MuiDialogContent: theme_overrides_dialogContent.MuiDialogContent,
    MuiDialogContentText: theme_overrides_dialogContentText.MuiDialogContentText,
    MuiDialogActions: theme_overrides_dialogActions.MuiDialogActions,
    MuiDialogTitle: theme_overrides_dialogTitle.MuiDialogTitle,
    MuiSnackbarContent: theme_overrides_snackbarContent.MuiSnackbarContent,
    MuiTooltip: theme_overrides_tooltip.MuiTooltip,
    MuiChip: theme_overrides_chip.MuiChip,
    // TODO(07-07-20): Remove in a few weeks, this was renamed very recently
    MuiExpansionPanel: theme_overrides_accordion.MuiAccordion,
    MuiExpansionPanelSummary: theme_overrides_accordionSummary.MuiAccordionSummary,
    MuiExpansionPanelDetails: theme_overrides_accordionDetails.MuiAccordionDetails,
    MuiTableCell: theme_overrides_tableCell.MuiTableCell,
    MuiTableContainer: theme_overrides_tableContainer.MuiTableContainer,
    MuiTableHead: theme_overrides_tableHead.MuiTableHead,
    MuiTableRow: theme_overrides_tableRow.MuiTableRow,
    MuiTableSortLabel: theme_overrides_tableSortLabel.MuiTableSortLabel,
    MuiTable: theme_overrides_table.MuiTable,
    MuiCardActionArea: theme_overrides_cardActionArea.MuiCardActionArea,
    MuiMenu: theme_overrides_menu.MuiMenu,
    MuiDivider: theme_overrides_divider.MuiDivider,
};
/**
 * Needs some type rework.
 *
 * CustomOverrides should be done properly so it will enforce correct keys.
 * 'overrides' should be the 'Overrides' type and skip the 'as' part.
 */
const getOverrides = (themeVariant) => {
    const overrides = {};
    Object.keys(allVariantOverrides).forEach((key) => {
        const override = allVariantOverrides[key];
        const themeOverride = override[themeVariant] || override.light;
        overrides[key] = themeOverride;
    });
    return overrides;
};

module.exports = getOverrides;
